/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const BranchDetailPage = lazyLoad(
  () => import('./index'),
  module => module.BranchDetailPage
);
